const ScrollOffset = {
    All: [
        [0, 0],
        [1, 1],
    ],
};

export { ScrollOffset };
//# sourceMappingURL=presets.mjs.map
